const stylesheets = new Map();

async function fetchStylesheet(url, cache = "default") {
  const response = await fetch(url, { cache });
  if (!response.ok) {
    throw new Error(`Unable to load ${url}: ${response.status}`);
  }
  const css = await response.text();
  if (!css.trim()) {
    // Firefox can return an empty body for an otherwise successful CSS request.
    // Bypass that cached response once instead of accepting an unstyled page.
    if (cache === "default") return fetchStylesheet(url, "reload");
    throw new Error(`Empty stylesheet: ${url}`);
  }
  return css.replace(/:root\b/g, ":host");
}

export default function loadMirrorStylesheet(url) {
  // The page and footer share these assets. Share both pending and completed
  // loads, without letting either component's unmount abort the other's CSS.
  if (!stylesheets.has(url)) {
    const request = fetchStylesheet(url).catch((error) => {
      stylesheets.delete(url);
      throw error;
    });
    stylesheets.set(url, request);
  }
  return stylesheets.get(url);
}
